<template>
  <BaseTableView :head="tableHead">
    <EmployeesGroupSelectWorkTypeExtraTableItem
      v-for="(item, key) in items"
      :key="key"
      :item="item"
    />
  </BaseTableView>
</template>

<script>
import EmployeesGroupSelectWorkTypeExtraTableItem from './EmployeesGroupSelectWorkTypeExtraTableItem'
export default {
  name: 'EmployeesGroupSelectWorkTypeExtraTable',
  props: { items: Array },
  components: { EmployeesGroupSelectWorkTypeExtraTableItem },
  data() {
    return {
      tableMin: false,
    }
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'nazvanie-proekta'
          ],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'vid-rabot'
          ],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'data'
          ],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'sotrudnik'
          ],
        },
        {text: '', active: true},
      ]
    },
    filterDataTableMin() {
      let result = {}
      for (let work of this.items) {
        if (!result[work.project_work_type.project.id]) {
          result[work.project_work_type.project.id] = {
            project_id: work.project_work_type.project.id,
            project_name: work.project_work_type.project.name,
            items: [],
          }
          let project = result[work.project_work_type.project.id]
          project.items.push(work)
        } else {
          let project = result[work.project_work_type.project.id]
          project.items.push(work)
        }
      }
      return result
    },
  },
}
</script>
